import {GIH_FAILURE, GIH_PENDING, GIH_SUCCESS} from './constants'
import {getItemsHistory as getItemsHistoryAPI} from '../../../services/audits'

export async function getItemsHistory(data, dispatch) {
  dispatch({type: GIH_PENDING, payload: data})
  try {
    let response = await getItemsHistoryAPI(data)
    dispatch({type: GIH_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Item History Failed: ${data.id}`)
    dispatch({type: GIH_FAILURE, payload: e})
  }
}
